import React from 'react';
import { Dropdown } from 'antd';

export const LCDropdown = ({ overlay, trigger, children,disabled }) => {
    return <Dropdown overlay={overlay} trigger={trigger} disabled={disabled}>{children}</Dropdown>;
};
